import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { isFleetScopedRole } from "../../utils/authRoles";

const FLEET_ALLOWED_PATHS = ["/live-map", "/profile"];

export const FleetScopedRoute: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!isFleetScopedRole(user?.role)) {
    return <Outlet />;
  }

  const allowed = FLEET_ALLOWED_PATHS.some(
    (path) =>
      location.pathname === path || location.pathname.startsWith(`${path}/`),
  );

  if (!allowed) {
    return <Navigate to="/live-map" replace />;
  }

  return <Outlet />;
};
